import { createAppStore } from '@store/createAppStore';

import { ApiCallHistory, ApiStore } from './types';

export const [apiCallsStore, setApiCallsStore] = createAppStore<ApiStore>(
  {
    apiCalls: [],
  },
  'apiCallsStore',
);

export const addApiCall = (apiCallHistory: ApiCallHistory) => {
  setApiCallsStore('apiCalls', (apiCalls) => {
    const updatedApiCalls = [...apiCalls, apiCallHistory];
    return updatedApiCalls.slice(-10); // Keep only the last 10 calls
  });
};
